"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const DynamicForm_1 = __importDefault(require("./DynamicForm"));
const default_renderers_1 = __importDefault(require("../components/default-renderers"));
const defaultWrappers = __importStar(require("../components/default-wrappers"));
const shallow_equal_1 = __importDefault(require("../utils/shallow-equal"));
const Rex = ({ fusions = {}, renderers = {}, wrappers = {}, passthroughProps = {}, dispatchers, enableRulesets = true, renderInputs = true, useForm, derivedForm, }) => (react_1.default.createElement(DynamicForm_1.default, { fusions: fusions, renderers: { ...default_renderers_1.default, ...renderers }, wrappers: { ...defaultWrappers, ...wrappers }, passthroughProps: passthroughProps, dispatchers: dispatchers, enableRulesets: enableRulesets, renderInputs: renderInputs, useForm: useForm, derivedForm: derivedForm }));
const areEqual = (prevProps, nextProps) => prevProps.derivedForm === nextProps.derivedForm &&
    [
        'enableRulesets',
        'renderInputs',
        'passthroughProps',
        'useForm',
    ].every(propName => (0, shallow_equal_1.default)(prevProps[propName], nextProps[propName]));
exports.default = react_1.default.memo(Rex, areEqual);
//# sourceMappingURL=Rex.js.map